import BaseAsyncSelectField from './BaseAsyncSelectField';

export default BaseAsyncSelectField;
